<div class="subscriptions-layout">
  <a routerLink="/dashboard" class="back-link">
    <i class="bi bi-arrow-left"></i> Back to Dashboard
  </a>

  <h1 class="page-title">Subscriptions</h1>
  <p class="page-subtitle">
    @if (brand.showBilling) {
      Review access, renewal, cancellation, and purchase options.
    } @else {
      This host includes ATPL-A for 6 months. No purchase is required.
    }
  </p>

  <div class="panel subscriptions-panel">
    <div class="panel-header">
      <label class="panel-label mb-0">{{ brand.productName }} Pro</label>
      <div class="panel-actions" *ngIf="brand.showBilling">
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="refreshRevenueCat()"
          [disabled]="rcLoading || !rcEnabled"
          title="Refresh RevenueCat status">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>
    <div class="panel-body">
      <p *ngIf="!brand.showBilling" class="alert alert-success mb-0">
        ATPL-A is included for 6 months on this host. RevenueCat billing is skipped.
      </p>

      <p *ngIf="brand.showBilling && !rcEnabled" class="alert alert-warning mb-3">
        Subscription management is unavailable. Contact support if you need help with billing.
      </p>

      <div *ngIf="rcEnabled && rcLoading" class="panel-loading mb-2">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Loading RevenueCat…
      </div>

      <div *ngIf="rcError" class="alert alert-danger">{{ rcError }}</div>
      <div *ngIf="rcInfoMessage" class="alert alert-info">{{ rcInfoMessage }}</div>

      <div *ngIf="rcEnabled && !rcLoading" class="rc-summary mb-3">
        <div class="row g-2 small">
          <div class="col-md-4">
            <div class="text-muted">Entitlement</div>
            <div class="fw-semibold">{{ revenueCat.entitlementId }}</div>
          </div>
          <div class="col-md-4">
            <div class="text-muted">Pro access</div>
            <div class="fw-semibold">
              <span *ngIf="rcProActive === true" class="text-success">Active</span>
              <span *ngIf="rcProActive === false" class="text-secondary">Not active</span>
              <span *ngIf="rcProActive === null" class="text-muted">—</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="text-muted">{{ willRenew === false ? 'Access until' : 'Next renewal' }}</div>
            <div class="fw-semibold">{{ renewalDate ? (renewalDate | date:'mediumDate') : 'Not available' }}</div>
          </div>
        </div>
      </div>

      <div *ngIf="rcEnabled" class="d-flex flex-wrap gap-2 mb-3">
        <a
          *ngIf="managementUrl"
          class="btn btn-primary btn-sm"
          [href]="managementUrl"
          target="_blank"
          rel="noopener noreferrer">
          Manage renewal or cancel
        </a>
        <button
          type="button"
          class="btn btn-outline-primary btn-sm"
          (click)="openPaywall()"
          [disabled]="rcLoading">
          <i class="bi bi-grid-1x2"></i> View plans
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="purchasePlan('monthly')" [disabled]="rcLoading">
          Buy monthly
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="purchasePlan('six_month')" [disabled]="rcLoading">
          Buy six month
        </button>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="purchasePlan('yearly')" [disabled]="rcLoading">
          Buy yearly
        </button>
      </div>

      <p *ngIf="rcEnabled && rcProActive && !managementUrl" class="alert alert-info mb-3">
        Your purchase provider did not supply an online management link. Contact support to change or cancel your subscription.
      </p>

      <p *ngIf="brand.showBilling" class="small text-muted mb-2">
        Cancellation stops future renewals. Refund and statutory withdrawal rights depend on your location,
        purchase channel, and when digital access started. Read the <a routerLink="/terms">subscription terms</a>
        @if (brand.supportEmail) {
          or email <a [href]="'mailto:' + brand.supportEmail">{{ brand.supportEmail }}</a> for a refund or withdrawal request.
        }
      </p>

      <div #rcPaywallHost class="rc-paywall-host" aria-live="polite"></div>
    </div>
  </div>

</div>
